// Absolute imports
import $ from 'jquery';
import DDTemplates from 'dd-templates';
// Relative imports
import Menu from './Menu';
import Drupal from './Drupal';
import Header from './Header';
import Gallery from './Gallery';
import Toolbar from './Toolbar';
import MobileMenu from './MobileMenu';
import SmartFooter from './SmartFooter';
import CalendarFeed from './CalendarFeed';
import FixNavigation from './FixNavigation';
import TermNavigation from './TermNavigation';
// Relative theme specific imports
import Strip from './Strip';
import Notification from './Notification';
import DistrictAlert from './DistrictAlert';
import PopupAlert from './PopupAlert';
import BackgroundImage from './BackgroundImage';
import Placeholder from './Placeholder';
import Parallax from './Parallax';
import Expanded from './Expanded';
import TwitterFeed from './TwitterFeed';
import StoriesSlider from './StoriesSlider';
import Translate from './Translate';
import Video from './Video';

// Add the theme behaviors

Drupal.behavior((context) => {
  // Helpers

  const $body = $(document.body, context);

  // DD Template Behaviors

  // eslint-disable-next-line no-new
  new DDTemplates(context);

  // Fix our damn menus from displaying orphaned children

  $('.primary-navigation, .term-nav', context).each((i, element) => {
    if (!element.FixNavigation) {
      element.FixNavigation = new FixNavigation(element);
    }
  });

  // Get bundled content from URL
  const postUrl = $('.hero.banner .node-header a', context).attr('href');
  $.get(postUrl, (data) => {
    const elements = $(data);
    const bundledContent = $('.bundled-posts article', elements);
    bundledContent.each((i, element) => {
      $('.bundled-wrapper').append(element);
    });

    // Add a wrapper around bundled content items that contains a URL to the node
    $('.hero.banner .node-inner', context).each((i, element) => {
      $('.bundled-wrapper .links', element).each((j, item) => {
        const wrapper = $(item).parent().parent().parent();
        const newLink = document.createElement('a');
        $(newLink).addClass('wrapped-link');
        $(newLink).attr('href', $(item).find('.link-read-more a').attr('href'));
        wrapper.wrap(newLink);
      });
    });
  });

  // Add wrapper for bundled content
  $('.hero.banner .views-row .node-inner', context).each((i, element) => {
    const d = document.createElement('div');
    $(d).addClass('bundled-wrapper');
    $(d).appendTo(element);
  });

  // Move .node-image to another parent
  $('.hero.banner .node-image', context).each((i, element) => {
    $('.hero.banner article').append(element);
  });

  $('.hero.banner .node-inner', context).each((i, element) => {
    const elements = $(element).find('.node-upper-meta, .node-header, .node-content, .node-links');
    const newElement = document.createElement('div');
    $(newElement).addClass('content-inner');
    $(elements).each((j, item) => {
      newElement.append(item);
    });
    element.append(newElement);
  });

  // Main/Primary Site Navigation
  $('#block-nice_menus-3', context).each((i, element) => {
    if (!element.menu && !element.mobileMenu) {
      element.menu = new Menu(element);
      element.mobileMenu = new MobileMenu(element);
    }
  });

  // Notifications

  $('#block-views_blocks-term-block_1-4', context).each((i, element) => {
    if (!element.Notification) {
      element.Notification = new Notification(element);
    }
  });

  // District Alerts

  $('#block-views_blocks-term-block_1-11', context).each((i, element) => {
    if (!element.DistrictAlert) {
      element.DistrictAlert = new DistrictAlert(element);
    }
  });

  // Popup Alert

  $('.popup-alert', context).each((i, element) => {
    if (!element.PopupAlert) {
      element.PopupAlert = new PopupAlert(element);
    }
  });

  // Resource Slidemenus

  $('.slidemenu.block .views-row', context).each((i, element) => {
    if (!element.Expanded) {
      element.Expanded = new Expanded(element);
    }
  });

  // Twitter Feed

  $('.twitter-feed', context).each((i, element) => {
    if (!element.TwitterFeed) {
      element.TwitterFeed = new TwitterFeed(element);
    }
  });

  // Stories Slider

  $('#block-views_blocks-term-block_1-8', context).each((i, element) => {
    if (!element.StoriesSlider) {
      element.StoriesSlider = new StoriesSlider(element);
    }
  });

  // Controls the states of the menu and search states

  $('.site-toolbar', context).each((i, element) => {
    if (!element.toolbar) {
      element.toolbar = new Toolbar(element);
    }
  });

  // Controls the page overlay display

  $('.overlay', context).bind('click', () => {
    $body.removeClass('menu-active search-active');
  });

  // Hero and Term Banner Parallax Backgrounds

  $('.banner.block .field-image a', context).each((i, element) => {
    if (!element.Parallax) {
      element.Parallax = new Parallax(element);
      $body.addClass('has-banner');
    }
  });

  // Hero Banner Video Backgrounds

  $('#block-views_blocks-term-block_1-6', context).each((i, element) => {
    if (!element.Video) {
      element.Video = new Video(element);
    }
  });

  // Pod Background Images

  $('.pods.block .node, .home-pods.block .node', context).each((i, element) => {
    if (!element.BackgroundImage) {
      element.BackgroundImage = new BackgroundImage(element);
    }
  });

  // Add placeholder text to all text and textarea components.

  $('.node-webform .type-textfield, .node-webform .type-textarea', context).each((i, element) => {
    if (!element.Placeholder) {
      element.Placeholder = new Placeholder(element);
    }
  });

  // Fixed Header using Headroom.js

  $('.headroom', context).each((i, element) => {
    if (!element.headroom) {
      element.headroom = new Header(element);
    }
  });

  // Smart Footer

  $('.page-footer', context).each((i, footer) => {
    const $footprint = $('.footprint', context);
    if (!footer.smartFooter && $footprint.length) {
      footer.smartFooter = new SmartFooter(footer, $footprint);
    }
  });

  // Term Navigation

  $('.term-nav', context).each((i, element) => {
    if (!element.termNavigation) {
      element.termNavigation = new TermNavigation(element);
    }
  });

  // Photo Galleries

  $('.node-content .photo-gallery, .photo-gallery .node-image, .photo-gallery .node-upper-image', context).each((i, element) => {
    if (!element.gallery) {
      element.gallery = new Gallery(element);
    }
  });

  // Calendar of Events View

  $('.calendar-feed', context).each((i, element) => {
    if (!element.calendarFeed) {
      element.calendarFeed = new CalendarFeed(element);
    }
  });

  // Strip various header links

  $('.footer-links .node-header a, .overview .node-header a', context).each((i, element) => {
    if (!element.strip) {
      element.strip = new Strip(element);
    }
  });

  // Relocate Google Translate dependent on viewport
  $('.page-header', context).each((i, element) => {
    if (!element.Translate) {
      element.Translate = new Translate(element);
    }
  });

  // Add Sitemap output using the digitaldcore.js function

  const $map = $('#sitemap', context);
  const $nav = $('#sitemap .content', context);

  if ($map.length && $nav.length) {
    Drupal.digitaldcoreCreateSiteMap($map, $nav);
    $map.addClass('ready');
  }
});



// WEBPACK FOOTER //
// ./theme.js